import {
  isEmpty,
  validateEmail,
  validateLength,
} from '../../../utility/validation';

const fields = [
  {
    name: 'email',
    type: 'email',
    label: 'email',
    required: true,
    validators: [
      {
        type: 'invalidEmailOrPassword',
        validator: isEmpty,
      },
      {
        type: 'invalidEmailOrPassword',
        validator: validateLength,
      },
      {
        type: 'invalidEmailOrPassword',
        validator: validateEmail,
      },
    ],
  },
  {
    name: 'password',
    type: 'password',
    label: 'password',
    required: true,
    shouldShowError: true,
    hasVisibilityToggle: true,
    validators: [
      {
        type: 'invalidEmailOrPassword',
        validator: isEmpty,
      },
    ],
  },
];

export default fields;
